import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

export type ActionType = 'create' | 'update' | 'delete';
@Component({
    selector: 'app-common-button',
    templateUrl: './common-button.component.html',
    styleUrls: ['./common-button.component.scss'],
    standalone: false
})
export class CommonButtonComponent implements OnInit {

   @Input() buttonId!: number;
  @Input() critical = false;
  @Input() variant: 'action' | 'cancel' = 'action';
  /* ===== UI ===== */
  @Input() label = '';
  @Input() title = '';
  @Input() icon?: string;

  @Input() width = '100px';
  @Input() height = '30px';
  @Input() fontSize = '12px';
  @Input() iconSize = '12px';
@Input() padding = '0px';
  /* ===== Action ===== */
   @Output() clicked = new EventEmitter<Event | void>();
   @Output() action = new EventEmitter<Function>(); 
  @Input() disabled: boolean;
  @Input() buttonClass = '';
  @Input() customStyles: { [key: string]: any } = {};


  backgroundColorButton;
  constructor(private localStorage: LocalStorageSettingsService) { }

  ngOnInit(): void {
    if (this.buttonId == undefined || this.buttonId == null) {
    throw new Error('buttonId is required for appCriticalOperation directive');
  }
     this.backgroundColorButton = this.localStorage.getSettings("ColorA");
  }
 onCriticalMethod = (event?:Event) => {
    this.handleClick(event);
  };
    handleClick(event ?:Event): void {
    this.clicked.emit(event);
     if (this.action.observers.length) {
    this.action.emit();
  }
  }

  get buttonStyles() {
    const defaultStyles: any = {};
  if (this.variant === 'cancel') {
    return {
      background: 'white',
      border: `1px solid ${this.backgroundColorButton}`,
      color: 'black'
    };
  }
  else {
    defaultStyles.backgroundColor = this.backgroundColorButton;
  }
   return {
    ...defaultStyles,
    ...this.customStyles
  };
  // action button (default)
  // return {
  //   background: this.backgroundColorButton,
  //   border: 'none'
  // };
}
}
